// Feature flag for the Video Guestbook module (guest Oscar recording flow + admin
// "Video Messages" gallery). Default OFF — opt in via REACT_APP_VIDEO_GUESTBOOK env,
// or per-browser via localStorage for testing. Mirrors auto-seating/seatingFlag.js.
//
// NOTE: the GUEST recording route (/guestbook/:token) is intentionally NOT gated by this
// flag — guests reach it by a private link/QR and must always be able to record. This flag
// only gates the ADMIN "Video Messages" tab inside the admin app.
// Host decision (2026-06-25): the Video Guestbook is a finished, shipped feature —
// no on/off switch. This is now an always-on shim so existing call sites need no
// change; there is no env var or per-browser toggle anywhere. (Revert to a real
// gate only if a future feature genuinely needs staged rollout.)
export function isVideoGuestbookEnabled() {
  return true;
}
